import React from 'react';
import { MdEdit } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { HeadingWithCreateBtn, Search, Table } from 'src/components';
import DashboardLayout from 'src/containers/dashboard-layout';
import useFetch from 'src/hooks/useFetch';
import AddCategory from './crud/AddCombo';
interface IProps {}

const Combo: React.FC<IProps> = ({}) => {
  const [query, setQuery] = React.useState('');

  const {
    data: comboData,
    fetchData,
    isLoading,
    errorText,
  } = useFetch('/combos');

  const navigate = useNavigate();

  const searchCategoryData = comboData?.combos?.filter(
    (item: { categoryInfo: { name: string } }) => {
      if (query === '') {
        return item;
      } else if (
        item?.categoryInfo.name?.toLowerCase().includes(query.toLowerCase())
      ) {
        return item;
      }
    }
  );

  const tableColumn = [
    {
      Header: 'Modifiers Name',
      accessor: 'name',
    },
    {
      Header: 'Price',
      accessor: 'price',
    },
    {
      Header: 'Action',
      Cell: (row: any) => (
        <div className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center">
          <MdEdit color="#4062FF" />
        </div>
      ),
    },
  ];
  return (
    <div className="grid-cols-12 gap-4 grid">
      <div className="col-span-12 ">
        <HeadingWithCreateBtn
          btnTxt="create combo"
          title="combo"
          onClick={() => navigate('/item-add-combo')}
        />
        {/* <Search
            placeholder="search combo ....."
            value={query}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setQuery(event?.target?.value)
            }
          /> */}

        <Table
          loading={isLoading}
          tableColumn={tableColumn}
          tableData={searchCategoryData}
        />
      </div>
      <div className="col-span-12 md:col-span-4" />
    </div>
  );
};

export default React.memo(Combo);
